jQuery.feature_import("js-customer-invoice",
    () => require("./CustomerInvoice.tsx"),
    mod => mod.feature_js_customer_invoice
);